import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { CustomSelect, CustomTextInput } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { filteredOptions, getProjectOptionName } from 'src/core/helpers'
import {
  projectFormStateSelector,
  projectOptionListSelector,
  setProjectFormItemValue
} from 'src/features'

const ProjectCertificationStandardSelect: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { kind, is_active } = useAppSelector(projectFormStateSelector)
  const { data: projectOptions } = useAppSelector(projectOptionListSelector)
  const options = filteredOptions(projectOptions, 'standard')

  const handleOnChange = (value: string) => {
    dispatch(setProjectFormItemValue({ key: 'standard', value }))
  }

  return <>
    {['compensation', 'carbon_forward'].includes(kind) ? (
      <CustomSelect
        name='standard'
        placeholder={t('Projects.Form.StandardPlaceholder')}
        onChange={(value: string) => handleOnChange(value)}
        required={is_active}
      >
        {options.map(po => (
          <Select.Option
            key={po.id}
            value={getProjectOptionName(po)}>
            {getProjectOptionName(po)}
          </Select.Option>
        ))}
      </CustomSelect>
    ) : kind === 'biodiversity' && (
      <CustomTextInput
        name='standard'
        placeholder={t('Projects.StandardPlaceholderX2')}
        onChange={e => handleOnChange(e.target.value)}
      />
    )}
  </>
}

export default ProjectCertificationStandardSelect
